module.exports = __webpack_public_path__ + "img/programme2.aa648e30.png";